module.exports = __webpack_public_path__ + "media/hero-video-more-2024.a86a0206.mp4";